import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const Textarea = ({
	className, name, id, value, placeholder, externalRef, cols, rows, onChange, onBlur
}) => {

	const { errors, register, triggerValidation } = useFormContext();

	const handleBlur = (e) => {

		if (typeof onBlur === 'function') {

			onBlur(e);

		}

		triggerValidation(name);

	};

	const handleChange = (e) => {

		if (typeof onChange === 'function') {

			onChange(e);

		}

		if (errors[name]) {

			triggerValidation(name);

		}

	};

	return (
		<textarea
			id={id}
			className={classNames(className, {
				error: Boolean(errors[name])
			})}
			name={name}
			onBlur={handleBlur}
			onChange={handleChange}
			placeholder={placeholder}
			ref={(e) => {

				register(e);
				if (externalRef) {

					// eslint-disable-next-line no-param-reassign
					externalRef.current = e;

				}

			}}
			value={value}
			cols={cols}
			rows={rows}
		/>
	);

};

Textarea.propTypes = {
	className: PropTypes.string,
	name: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	value: PropTypes.string,
	placeholder: PropTypes.string,
	externalRef: PropTypes.shape({
		current: PropTypes.any
	}),
	onChange: PropTypes.func,
	onBlur: PropTypes.func
};

export default Textarea;
